import React, { useState } from 'react';

const Toggle = ({ on, onChange, label }: { on: boolean; onChange: () => void; label: string }) => (
  <div className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0">
    <span className="text-sm text-gray-700">{label}</span>
    <button onClick={onChange} className={`relative w-11 h-6 rounded-full transition-colors ${on ? 'bg-blue-600' : 'bg-gray-300'}`}>
      <span className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform ${on ? 'translate-x-5' : ''}`} />
    </button>
  </div>
);

const Settings: React.FC = () => {
  const [notifs, setNotifs] = useState({ email: true, sms: true, browser: true, whale: true, compliance: true, agent12: true });
  const [thresh, setThresh] = useState({ whale: '15000', autonomy2: '2500', confidence: '95' });
  const [saved, setSaved] = useState(false);
  const save = () => { setSaved(true); setTimeout(() => setSaved(false), 3000); };

  return (
    <div className="space-y-6 max-w-2xl">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
        {saved && <span className="text-sm text-green-600 font-medium">✓ Settings saved</span>}
      </div>
      {[
        { title: 'Notification Preferences', content: (
          <div>
            {([['email','Email Notifications'],['sms','SMS Alerts (Twilio)'],['browser','Browser Notifications'],['whale','Whale Detection Alerts'],['compliance','Compliance Violation Alerts'],['agent12','Agent 12 Action Required']] as [keyof typeof notifs, string][]).map(([k,l]) => (
              <Toggle key={k} on={notifs[k]} onChange={() => setNotifs(p => ({ ...p, [k]: !p[k] }))} label={l} />
            ))}
          </div>
        )},
        { title: 'Agent Thresholds', content: (
          <div className="space-y-4">
            {([['whale','Whale Policy Threshold ($)','Policies above this amount escalate to Agent 12'],['autonomy2','Tier 2 Autonomy Threshold ($)','Policies below this auto-handle without approval'],['confidence','My Mini-Me Confidence Threshold (%)','Below this confidence, Mini-Me escalates to Agent 12']] as [keyof typeof thresh, string, string][]).map(([k,l,h]) => (
              <div key={k}>
                <label className="block text-sm font-medium text-gray-700 mb-1">{l}</label>
                <input type="number" value={thresh[k]} onChange={e => setThresh(p => ({ ...p, [k]: e.target.value }))}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                <p className="text-xs text-gray-500 mt-1">{h}</p>
              </div>
            ))}
          </div>
        )},
        { title: 'Platform', content: (
          <div className="space-y-3 text-sm text-gray-700">
            <div className="flex justify-between py-2 border-b border-gray-100"><span>Platform Version</span><span className="font-medium">V34.0.0</span></div>
            <div className="flex justify-between py-2 border-b border-gray-100"><span>Environment</span><span className="font-medium text-green-600">Production</span></div>
            <div className="flex justify-between py-2 border-b border-gray-100"><span>Domain</span><span className="font-medium">lifeandwealthsolutions.online</span></div>
            <div className="flex justify-between py-2"><span>Company</span><span className="font-medium">Phoenix Rescue Apps · Delaware</span></div>
          </div>
        )},
      ].map(s => (
        <div key={s.title} className="bg-white rounded-xl border border-gray-200 p-6">
          <h2 className="text-base font-semibold text-gray-900 mb-4">{s.title}</h2>
          {s.content}
        </div>
      ))}
      <button onClick={save} className="px-6 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium text-sm">Save Settings</button>
    </div>
  );
};
export default Settings;
